import type { QuickFilterDef } from './types'

export interface QuickFilterChipsProps {
  filters: QuickFilterDef[]
  activeIds: Set<string>
  onToggle: (id: string) => void
}

/** Instant inline chips for common cuts — single click toggles, combinable. */
export function QuickFilterChips({ filters, activeIds, onToggle }: QuickFilterChipsProps) {
  return (
    <div role="group" aria-label="Quick filters" style={{ display: 'flex', gap: 'var(--iw-space-2)', flexWrap: 'wrap' }}>
      {filters.map((filter) => (
        <button
          key={filter.id}
          type="button"
          className="iw-chip"
          aria-pressed={activeIds.has(filter.id)}
          onClick={() => onToggle(filter.id)}
        >
          {filter.label}
        </button>
      ))}
    </div>
  )
}
